<!-- @format -->
<script>
</script>

<main>
  <div class="container">
    <h1 id="privacy-policy">Privacy Policy</h1>
    <p>
      We prioritize the protection of personal information for our service users and comply with the privacy regulations established by relevant laws, including the Personal Information Protection Act. Our privacy policy is announced through the application screen or webpage (hereinafter referred to as 'app screen, etc.'). The term 'Service' refers to the service provided through the application screen or webpage. In case of amendments to the privacy policy, the reasons and content of the changes are notified through the designated procedures specified by relevant laws on the application screen, etc.<br>
      <br>
      We acknowledge your interest in understanding how your information is used and shared. This privacy policy adheres to the General Data Protection Regulation ('GDPR') of the European Union, the California Consumer Privacy Act ('CCPA'), and other related laws collectively referred to as 'Data Protection Laws'.
      <br>
      <br>
      <br>
      <strong class="strong-title">Information We Collect</strong>
      <br>
      <br>
      The types of information we process depend on how you use our services. Most of our services require account setup, including the collection and processing of your name and email address. Additional information may be required for other services.
      <br>
      <br>
      <strong>Information You Provide</strong>
      <br>
      <br>
      Basic account information, profile details, identity information, payment and billing details, user-generated content, survey information, messages, and other communications.
      <br>
      <br>
      <strong>Automatically Collected Information</strong>
      <br>
      <br>
      Usage data, location data, device information, information collected through cookies.
      <br>
      <br>
      We do not collect additional categories of personal information without first informing you within the scope required by data protection laws or obtaining your consent. Additionally, the personal information collected is not used for purposes that are substantially different, unrelated, or incompatible without notifying you or obtaining your consent, as required by data protection laws.
      <br>
      <br>
      <br>
      <strong class="strong-title">Sensitive Personal Data</strong>
      <br>
      <br>
      Data protection laws recognize the need for additional protection for certain types of information. In particular, GDPR prohibits the processing of sensitive personal data except in certain exceptional circumstances. Sensitive personal data in the EU includes information related to an individual's race or ethnicity, political opinions, religious or philosophical beliefs, trade union membership, biometric data, and data concerning an individual's health or sexual orientation. Specific state laws in the United States may provide different definitions for sensitive personal data.
      <br>
      <br>
      We do not intentionally collect or process sensitive personal data. However, some users may choose to disclose such information while using our services. For example, users may add personal information, such as a medical history, to their profiles. This is a voluntary option for users to include any information they desire, provided it complies with the relevant terms of service. Users have control over the information they share, and if they choose to disclose sensitive personal data, they can delete or modify this information at any time.
      <br>
      <br>
      <br>
      <strong class="strong-title">Entities with Whom We Share Data</strong>
      <br>
      <br>
      We collaborate with third-party service providers to facilitate the provision of our services. Our service providers are located globally, including in the United States.
      <br>
      <br>
      For residents of the European Economic Area (EEA), in the event that your information is transmitted outside the EEA, we will take measures to ensure that such information is protected in accordance with data protection laws, including compliance with the General Data Protection Regulation (GDPR) of the European Union.
      <br>
      <br>
      <strong>Transfer to Third Parties</strong>
      <br>
      <br>
      <strong>Hosting Service Providers: </strong>Your Information
      <br>
      <br>
      <strong>Customer Support Service Providers: </strong>Basic account information, payment and billing details, messages and other communications, location data, device information, and user reports
      <br>
      <br>
      <strong>Customer Data Analytics Service Providers (e.g., Google Analytics): </strong>Basic account information, location data, usage information, analytics, and aggregated information
      <br>
      <br>
      <strong>Paid Search Advertising Analytics (e.g., Google Ads): </strong>Basic account information, automatically collected information, analytics, and aggregated information
      <br>
      <br>
      <strong>Payment Processing Service Providers (e.g., Paddle): </strong>Basic account information, payment and billing details
      <br>
      <br>
      <strong>Email Service Providers: </strong>Basic account information
      <br>
      <br>
      <br>
      <strong class="strong-title">Your Rights</strong>
      <br>
      <br>
      Global data protection laws, including GDPR and CCPA, provide users with specific rights regarding how their personal data is used by the company. Under these regulations, our group of companies ensures that users have the right to access, modify, and delete the information they have provided.
      <br>
      <br>
      <strong>Refusal of Information Submission: </strong>You have the option to refuse the submission of personal information through the service, and in such cases, we may not be able to provide you with specific services.
      <br>
      <br>
      <strong>Unsubscribe from Marketing Emails: </strong>To unsubscribe from specific newsletter subscriptions, please click the "Unsubscribe" link at the bottom of the respective email newsletter. When sending newsletters, we may allow advertisers or partners to include messages in the newsletter or send exclusive newsletters and marketing messages on behalf of advertisers or partners. In accordance with applicable laws, we may disclose your refusal preferences to third parties to respect your choices.
      <br>
      <br>
      <strong>Blocking Cookies: </strong>Certain browsers may be configured to notify you when you receive cookies or restrict/disable specific cookies. However, if you choose to disable cookies, it may affect specific features of services that use cookies to enhance functionality.
      <br>
      <br>
      <strong>Withdrawal of Consent: </strong>If we process your information based on your consent, you can withdraw your consent at any time. If you withdraw consent, we may not be able to perform certain services, such as device linking or specific ad delivery, conditioned on your consent.
      <br>
      <br>
      <br>
      <strong class="strong-title">Right to Deletion Request</strong>
      <br>
      <br>
      You have the right, with certain exceptions, to request the deletion of your personal information collected and held by us. Upon receiving and verifying your verifiable consumer request, we will delete your personal information from our records (instructing service providers to do the same), unless exceptions apply. We may deny your deletion request if we or the service provider need to retain the information for the following purposes.
      <br>
      <br>
      <br>
      <strong class="strong-title">Data Security and Data Breach</strong>
      <br>
      <br>
      We are committed to safeguarding the integrity and security of your information and have implemented appropriate technical and organizational security measures to protect your information from illegal or unauthorized destruction, loss, alteration, disclosure, acquisition, or access.
      <br>
      <br>
      Our group companies generally adhere to industry standards recognized for protecting personal data transmitted to and received by us. Examples of our security measures include access locks on servers, implementation of IT measures such as encryption, and physical measures such as access restrictions to your information through authorization and passwords.
      <br>
      <br>
      Depending on the respective group company and service, your account information is password-protected. It is your responsibility to carefully choose a sufficiently strong password, change it periodically, and keep your password confidential. Additionally, you are responsible for controlling access to your email communications with our group companies and other security measures such as logging out after using our services.
      <br>
      <br>
      Despite these measures, it is impossible to guarantee the security of all information you transmit to our group companies or ensure that your information about our services will not be accessed, disclosed, altered, or destroyed due to a technical or organizational breach on our part. Your privacy settings may also be affected by changes in the features of our group company distributors, such as social networks. We do not assume responsibility for the features or security measures of third parties.
      <br>
      <br>
      <br>
      <strong class="strong-title">Data Retention</strong>
      <br>
      <br>
      We retain personal data only for the period necessary for the purposes of processing the data, including the provision of services. The retention period is determined on a case-by-case basis and varies based on several factors, including:
      <br>
      <br>
       - The type of information and processing purposes.
      <br>
      <br>
       - Legal obligations, such as retaining data processed in specific locations due to legal requirements or until the statute of limitations for possible legal claims or investigations has elapsed.
       <br>
       <br>
       After termination or deactivation of your user account, we may retain the information you provided for a commercially reasonable period for purposes such as backups, record-keeping, contract fulfillment, enforcement, or audits, provided that we do not exceed the necessary period and the information remains accurate and relevant for our use. Additionally, even after the termination or deactivation of your user account, we may retain indefinitely and continue to use any information included in your communications with other users or posted in public or semi-public areas of the service. However, we will only retain this information within the posted service and will not use it for other purposes.
       <br>
       <br>
       <br>
       <strong class="strong-title">Changes to Privacy Policy</strong>
       <br>
       <br>
       As our services continue to evolve and grow, the way we process data will develop over time. To reflect changing practices, we periodically update this policy and inform you of significant changes through the following methods: i) sending an email to the address provided when signing up for our services, or ii) posting notices on the website or app of the respective group company.
       <br>
       <br>
       <br>
       <strong class="strong-title">Contact Information</strong>
       <br>
       <br>
       If you have any questions regarding this privacy policy or if you have data protection inquiries related to the group company or services, you can contact the Data Protection Officer at <a href="mailto:admin@shortcase.link">admin@shortcase.link</a>.
       <br>
       <br>Last updated: (Jan 31, 2024)
       <br>
       <br>
       <br>
       <br>
    </p>
      
    <!-- </p> -->
  </div>
</main>

<style>
  .container {
    padding-top: 2em;
    padding-left: 2em;
    padding-right: 2em;
    padding-bottom: 4em;
    height: 100vh;
  }
  .strong-title {
    font-weight: 700;
    font-size: 1.5em;
  }

  h1 {
    /* color: #4b494e; */
    color: white;
  }

  p {
    /* color: #4b494e; */
    color: white;
  }

  li {
    /* color: #4b494e; */
    color: white;
  }

  h1, h2, h3, h4, h5, h6, p {
    font-family: 'Lato', sans-serif;
    /* color: black; */
    color: white;
  }
</style>

<!-- <main>
  <div class="container">
    <h1 id="privacy-policy">Privacy Policy</h1>
    <p>
      We values the personal information of the users of service and complies
      with privacy regulations provided under relevant statutes such as the
      Personal Information Protection Act, etc. We notifies the privacy policy
      through the application screen or webpage (hereinafter referred to as
      “application screen, etc.”) that provides service (hereinafter referred to
      as “service”). When revising the privacy policy, it notifies the reason
      and details of the change through the application screen and etc.
      accordingly with the procedures prescribed by the relevant statutes.
    </p>
    <p>
      <strong>1. Information to be collected and method of collection</strong>
    </p>
    <p>
      We collect the minimum amount of personal information necessary for the
      provision of service.
    </p>
    <ul>
      <li>Email, Name, Business card, Location</li>
    </ul>
    <p>We collect the information of users in a way of the followings:</p>
    <ul>
      <li>Provided by the users through service</li>
    </ul>
    <p><strong>2. Purposes of collection and usage of information</strong></p>
    <p>We use the collected information in a way of the followings:</p>
    <ul>
      <li>Member management and service provision</li>
      <li>
        Member management and identification for entering, performing and
        terminating the contract concerning service provision
      </li>
      <li>
        Archival of records for user communication service and any possible
        dispute settlements
      </li>
      <li>
        Making notice of function of project or matters on service or policy
        change
      </li>
      <li>
        Detecting and deterring unauthorized or fraudulent use of abuse of the
        Service
      </li>
      <li>Improvement of existing services and development of new services</li>
    </ul>
    <p><strong>3. Disclosure of information to third-party</strong></p>
    <p>
      We utilize personal information under the scope mentioned in section 2
      Purposes of collection and usage of information. In principle, we don’t
      disclose information to third parties without a legal basis or prior
      consent of the users.
    </p>
    <p>
      <strong
        >4. Procedure and method of destruction of personal information</strong
      >
    </p>
    <p>
      In principle, We destruct the information once the purpose of information
      collection and use have been achieved.
    </p>
    <p>
      <strong
        >5. Rights of users &amp; legal representatives and methods of exercise
        thereof</strong
      >
    </p>
    <p>
      ① Users and legal representatives can view or update personal information
      of themselves at any time, and revoke their consent for the collection,
      use, and provision of personal information as a method of termination of
      membership (withdrawal from membership). However, since the project team
      collects and uses only the essential information necessary for the
      service, it is impossible to withdraw only parts of the consent.
    </p>
    <p>
      ② When a user requests the correction of errors in his/her personal
      information, the relevant personal information will not be used or
      provided to a third party until the correction is made. If any incorrect
      information has already been provided to a third party, the corrected
      information will be immediately notified to the third party without delay
      as to ensure that the necessary correction is made.
    </p>
    <p>
      <strong
        >6. Matters concerning the installation/operation of an automatic
        personal information collection Device and the rejection thereof</strong
      >
    </p>
    <p>
      When a user accesses the application screen of service, We use ‘cookies’
      that frequently save and retrieve user’s information to provide
      personalized and customized services. A cookie is a very small text file
      that the server, used to operate the project team’s website, sends it to a
      user’s browser. It is saved in the hard disk of the user’s computer or
      other access media (including mobile devices such as smartphones and
      tablet PCs).
    </p>
    <p>① Purpose of cookies usage</p>
    <p>
      We store the cookies to save user’s login information and increase user
      convenience by enabling automatic login. We do not store cookies for any
      other purpose.
    </p>
    <p>
      <strong
        >7. Technical/administrative measures to protect personal information</strong
      >
    </p>
    <p>
      To prevent personal information from being lost, stolen, leaked, altered
      or damaged and ensure safety when handling the personal information of
      information principals, We take the following technical/administrative
      measures:
    </p>
    <p>① Encryption of personal information</p>
    <p>
      We encrypt and stores all personal information items in accordance with
      the relevant laws and guidelines of relevant administrative agencies.
    </p>
    <p>② Technical measures against hacking, etc.</p>
    <p>
      We are operating an intrusion prevention system to prevent leakage of
      and/or damage on personal information of its members by hacking servers,
      networks, etc.
    </p>
    <p>③ Minimum number of handling personnel and provision of training</p>
    <p>
      We strictly limits employees handing personal information to those who
      manage personal information. We also provide regular education for
      employees on the importance of security. Moreover, we monitor compliance
      with personal information protection policy and of personnel in charge,
      and if related problems are detected, the project team provides efforts to
      immediately take corrective measures.
    </p>
    <p>
      <strong
        >8. Contact information of chief privacy officer and administrators</strong
      >
    </p>
    <p>
      We have the chief privacy officer and the manger to protect the personal
      information of the users and deal with complaints related the personal
      information.
    </p>
    <p>Email: admin@shortcase-app.com</p>
    <p><strong>9. Coverage</strong></p>
    <p>This Privacy Policy applies to our all service.</p>
    <p><strong>10. Duty of notification</strong></p>
    <p>
      When there is an addition, a deletion, or a correction of the content of
      the current Privacy Policy, the project team will inform the service users
      through the ‘Notification’ on the application screen (7) days before the
      implementation of such changes. However, if personal information
      collection, use, and provision to a third party are changed against the
      users, we will notify them at least 30 days in advance.
    </p>
    <p>Effective date: Oct 28th, 2023</p>
  </div>
</main>

<style>
  .container {
    padding-top: 2em;
    padding-left: 3em;
    padding-right: 3em;
    padding-bottom: 4em;
  }

  h1 {
    color: #4b494e;
  }

  p {
    color: #4b494e;
  }

  li {
    color: #4b494e;
  }
</style> -->
